import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/homeData';

export default function FeaturedSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-accent-500 text-xs font-medium tracking-wider uppercase">
              编辑精选
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              精选全网最受欢迎的韩国漫画，每一部都值得珍藏
            </p>
          </div>
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to="/"
              className="group cursor-pointer"
            >
              <div className={`rounded-2xl overflow-hidden ${comic.bgColor} mb-3`}>
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫漫画网站`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-foreground-950 text-base group-hover:text-accent-500 transition-colors">
                  {comic.title}
                </h3>
                <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                  <span>{comic.category}</span>
                  <span className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {comic.rating}
                  </span>
                  <span className="text-accent-600 font-medium">{comic.updateChapter}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}